import React from "react";
import "../assets/css/error.css";
import { MdArchitecture } from "react-icons/md";
import { AiOutlineDesktop } from "react-icons/ai";
import { GoLaw } from "react-icons/go";
import { GiPlantsAndAnimals } from "react-icons/gi";
import { BiVideoRecording, BiCapsule } from "react-icons/bi";
import { BsGlobe, BsBuilding, BsXDiamond } from "react-icons/bs";
import { RiCalculatorLine } from "react-icons/ri";
import { TbCertificate } from "react-icons/tb";
import { IoIosDesktop } from "react-icons/io";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import { GiCommercialAirplane } from "react-icons/gi";
import { RiPenNibLine } from "react-icons/ri";
import careersLogo from "../assets/images/logo-blue.svg";
import {Helmet} from "react-helmet";
import axios from "axios";
const NotFound = () => {
  return (
    <>
      <Helmet>
          <title>404 Page Not FOund</title>
      </Helmet>

      <div className={"header_border"}>
        <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
          <img
            src={careersLogo}
            alt="Careers360 Logo"
            width={166}
            height={20}
          />
        </a>
      </div>

      <div className="not_found">
        <div className="container">
        <img src={require("../assets/images/error_404.png")} alt="" />
          
          <h1>Page Not Found</h1>
          <h4>
            Check that you typed the address correctly, go back to your previous
            page or try using out site search to find something specific
          </h4>
          <div className="button_card">
            <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`} className="btn_active">
              Go to Homepage
            </a>
          </div>
          <h5>Here are a few links that might be helpful:</h5>
          <div className="domains_card_cover">
            <div className="domains_card">
              <a href={`https://engineering.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <MdArchitecture />
                </span>
                <p>Engineering and Architecture</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/mba`}>
                <span>
                  <AiOutlineDesktop />
                </span>
                <p>Management and Business Administration</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://law.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <GoLaw />
                </span>
                <p>Law</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://design.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}`}>
                <span>
                  <GiPlantsAndAnimals />
                </span>
                <p>Animation and Design</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/media-journalism`}>
                <span>
                  <BiVideoRecording />
                </span>
                <p>Media Journalism</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://medicine.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <BiCapsule />
                </span>
                <p>Medicine and Allied Sciences</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://university.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <BsGlobe />
                </span>
                <p>Arts, Humanities and Social Sciences</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/commerce`}>
                <span>
                  <RiCalculatorLine />
                </span>
                <p>Commerce</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/it`}>
                <span>
                  <IoIosDesktop />
                </span>
                <p>Computer Application and IT</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/pharmacy`}>
                <span>
                  <MdOutlineLocalPharmacy />
                </span>
                <p>Pharmacy</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/hospitality`}>
                <span>
                  <GiCommercialAirplane />
                </span>
                <p>Hospitality and Tourism</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://competition.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <RiPenNibLine />
                </span>
                <p>Competition</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://school.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>
                <span>
                  <BsBuilding />
                </span>
                <p>Schools</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/courses-certifications/all-courses`}>
                <span>
                  <TbCertificate />
                </span>
                <p>Certifications</p>
              </a>
            </div>
            <div className="domains_card">
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/premium`}>
                <span>
                  <BsXDiamond />
                </span>
                <p>Careers360 Premium</p>
              </a>
            </div>
          </div>
          <ul>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/college-predictor`}>
                College Predictor
              </a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/rank-predictor`}>
                Rank Predictor
              </a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/colleges/india-colleges-fctp`}>
                Colleges
              </a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/application-forms/colleges`}>
                Applications Open
              </a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/qna`}>QnA</a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/articles`}>Articles</a>
            </li>
            <li>
              <a href={`https://news.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/`}>News</a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/courses-certifications/online-degree-diploma-courses`}>
                Online Degree
              </a>
            </li>
            <li>
              <a href={`https://www.${axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME}/download/ebooks-and-sample-papers`}>
                E-Books
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default NotFound;